<!--
 * @Author: cgh
 * @Date: 2022-08-01 12:03:08
 * @LastEditors: DQL
 * @LastEditTime: 2022-10-04 00:47:06
 * @Description: 评估项目添加/修改
-->
<template>
  <el-form
    ref="fd"
    class="c-form"
    :model="fd"
    :inline="true"
    label-position="right"
    label-width="150px"
    label-suffix="："
  >
    <el-row class="c-form__row">
      <el-col
        class="c-form__col c-form__part-title"
        :span="24"
      >
        基础信息
      </el-col>
      <el-col
        class="c-form__col"
        :span="12"
      >
        <el-form-item
          class="c-form__item"
          label="委托单位"
          prop="wtdw"
        >
          <template>
            {{ fd.wtdw || '-' }}
          </template>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="12"
      >
        <el-form-item
          class="c-form__item"
          label="联系人"
          prop="lxr"
        >
          <template>
            {{ fd.lxr || '-' }}
          </template>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="12"
      >
        <el-form-item
          class="c-form__item"
          label="委托单位地址"
          prop="wtdwdz"
        >
          <template>
            {{ fd.wtdwdz || '-' }}
          </template>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="12"
      >
        <el-form-item
          class="c-form__item"
          label="联系电话"
          prop="lxdh"
        >
          <template>
            {{ fd.lxdh || '-' }}
          </template>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="12"
      >
        <el-form-item
          class="c-form__item"
          label="项目名称"
          prop="xmmc"
        >
          <template>
            {{ fd.xmmc || '-' }}
          </template>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="12"
      >
        <el-form-item
          class="c-form__item"
          label="统一社会信用代码"
          prop="shxydm"
        >
          <template>
            {{ fd.shxydm || '-' }}
          </template>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="12"
      >
        <el-form-item
          class="c-form__item"
          label="所属区域"
          prop="areaMc"
        >
          <template>
            {{ fd.areaMc || fd.areaDm || '-' }}
          </template>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="12"
      >
        <el-form-item
          class="c-form__item"
          label="项目地址"
          prop="xmdz"
        >
          <template>
            {{ fd.xmdz || '-' }}
          </template>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="12"
      >
        <el-form-item
          class="c-form__item"
          label="建筑类型"
          prop="jzlbMc"
        >
          <template>
            {{ jzlbMc }}
          </template>
        </el-form-item>
      </el-col>

      <el-col
        class="c-form__col"
        :span="12"
      >
        <el-form-item
          class="c-form__item"
          label="管理单位"
          prop="gldw"
        >
          <template>
            {{ fd.gldw || '-' }}
          </template>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="12"
      >
        <el-form-item
          class="c-form__item"
          label="维保单位"
          prop="wbdw"
        >
          <template>
            {{ fd.wbdw || '-' }}
          </template>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col  c-form__placeholder"
        :span="12"
      />
      <el-col
        class="c-form__col"
        :span="24"
      >
        <el-form-item
          class="c-form__item"
          label="单位基本情况"
          prop="dwjbqk"
        >
          <textarea-read
            v-model="fd.dwjbqk"
            class="c-form__read u-line-20"
          />
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="24"
      >
        <el-form-item
          class="c-form__item"
          label="建筑基本信息"
          prop="jzjbqk"
        >
          <textarea-read
            v-model="fd.jzjbqk"
            class="c-form__read u-line-20"
          />
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col c-form__part-title"
        :span="24"
      >
        评估信息
      </el-col>
      <el-col
        class="c-form__col"
        :span="12"
      >
        <el-form-item
          class="c-form__item"
          label="评估日期"
          prop="pgrq"
        >
          {{ fd.pgrqQ | date('yyyy-MM-dd') }} 至 {{ fd.pgrqZ | date('yyyy-MM-dd') }}
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col c-form__placeholder"
      />
      <el-col
        class="c-form__col"
        :span="12"
      >
        <el-form-item
          class="c-form__item"
          label="报告编写人"
          prop="bgbxrMc"
        >
          <template>
            {{ fd.bgbxrMc || '-' }}
          </template>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="12"
      >
        <el-form-item
          class="c-form__item"
          label="项目负责人"
          prop="xmfzrMc"
        >
          <template>
            {{ fd.xmfzrMc || '-' }}
          </template>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="12"
      >
        <el-form-item
          class="c-form__item"
          label="报告审批人"
          prop="bgsprMc"
        >
          <template>
            {{ fd.bgsprMc || '-' }}
          </template>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="12"
      >
        <el-form-item
          class="c-form__item"
          label="报告批准人"
          prop="bgpzrMc"
        >
          <template>
            {{ fd.bgpzrMc || '-' }}
          </template>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="24"
      >
        <el-form-item
          class="c-form__item"
          label="评估范围"
          prop="pgfw"
        >
          <textarea-read
            v-model="fd.pgfw"
            class="c-form__read u-line-20"
          />
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="24"
      >
        <el-form-item
          class="c-form__item"
          label="评估依据"
          prop="pgyj"
        >
          <template>
            <div class="o-text-pgyj">
              {{ pgyjStr || '-' }}
            </div>
            <el-popover
              v-if="pgyjList.length > 4"
              placement="right"
              width="400"
              trigger="click"
            >
              <div style="white-space: pre-wrap;">
                {{ fd.pgyj || '-' }}
              </div>
              <el-link
                slot="reference"
                :underline="false"
                type="primary"
              >
                更多
              </el-link>
            </el-popover>
          </template>
        </el-form-item>
      </el-col>
      <!-- <el-col
        class="c-form__col"
        :span="24"
      >
        <el-form-item
          class="c-form__item"
          label="评估情况说明"
          prop="pgqksm"
        >
          <textarea-read
            v-model="fd.pgqksm"
            class="c-form__read u-line-20"
          />
        </el-form-item>
      </el-col> -->
    </el-row>
  </el-form>
</template>

<script>
import { pgxmManageService } from '../pgxm.service';
export default {
  name: 'ViewXminfo',
  props: {
    dlParams: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      loading: false, // 页面loading建筑类别
      dialogShow: true, // 模态框dialog显示
      xmid: null,
      /* 表单参数 Start */
      fd: {
        wtdw: null, // 委托单位
        lxr: null, // 联系人
        wtdwdz: null, // 委托单位地址
        lxdh: null, // 联系电话
        xmmc: null, // 项目名称
        shxydm: null, // 统一社会信用代码
        areaMc: null, // 所属区域
        xmdz: null, // 项目地址
        pgrq: [], // 评估日期
        pgrqQ: null, // 评估日期起
        pgrqZ: null, // 评估日期止
        qdxxList: [],
        jzlbMc: null, // 建筑类型
        bgbxrMc: null, // 报告编写人
        xmfzrMc: null, // 项目负责人
        bgsprMc: null, // 报告审批人
        bgpzrMc: null, // 报告批准人
        gldw: null, // 管理单位
        wbdw: null, // 维保单位
        pgfw: null, // 评估范围
        pgyj: null, // 评估依据
        dwjbqk: null,
        jzjbqk: null, // 建筑基本信息
        pgqksm: null, // 评估情况说明
        bgbh: null, // 报告编号
        bgUrl: null, // 报告编号路径
        lockVersion: null

      },
      pgyjStr: '', // 显示前4条评估依据数据
      pgyjList: [], // 存放评估依据数据

      qdxxListStr: '' // 显示前4条评估依据数据

    };
  },
  computed: {
    /* 根据模态框类型动态展示标题 */
    dlType () {
      return this.$route.params.type;
    },
    jzlbMc () {
      const enums = this.$store.state.apiEnums.iffApi;
      const typeMap = enums && enums.IFF_JZLB_PG ? enums.IFF_JZLB_PG : {};
      const types = Object.values(typeMap);
      const matched = types.find(item => item.id === this.fd.jzlbDm);
      return matched ? matched.text : (this.fd.jzlbDm || '-');
    }
  },
  methods: {
    /**
     * @description: 初始化信息
     * @return {*}
     */
    init () {
      this.loading = true;
      pgxmManageService.getDetail(this.xmid)
        .then(rsp => {
          this.fd = Object.assign({}, this.fd, rsp.data);

          // 获取评估依据前4条数据
          this.pgyjList = (this.fd.pgyj || '').split('\n');
          const _pgyjList = this.pgyjList.slice(0, 4);
          for (let i = 0; i < _pgyjList.length; i++) {
            this.pgyjStr += _pgyjList[i] + '\n';
          }
          this.$emit('updateXminfo', this.fd);
        })
        .catch(err => {
          console.error('获取评估项目信息错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.closeNavTabAndTo();
    }

  },
  created () {
    this.xmid = this.$route.params.id;
    this.init();
  }
};
</script>
<style scoped>
.o-text-pgyj {
  width: 100%;
  height: 100px;
  white-space: pre-wrap;
}
</style>
